<template>
  <div
    ref="input"
    contenteditable="true"
    @input="onInput"
    @blur="onBlur"
    @focus="onFocus"
    v-text="innerValue"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    }
  },

  data: () => ({ editing: false, innerValue: '' }),

  watch: {
    value(value) {
      if (!this.editing) this.innerValue = value
    }
  },

  created() {
    this.innerValue = this.value
  },

  methods: {
    focus() {
      this.$nextTick(() => this.$refs.input.focus())
    },
    onFocus() {
      this.editing = true
      this.$emit('focus')
    },
    onBlur() {
      this.editing = false
      this.$emit('blur')
    },
    onInput({ target }) {
      this.$emit('input', target.innerText)
    }
  }
}
</script>
